export const TagConst = {
  TAG_TYPES: {
    Tag: 'tag',
    SubIndustry: 'subIndustry',
    LawSchoolRank: 'lawSchoolRank',
  },
} as const;
